import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import { useTheme } from "@mui/material/styles";
import { useRef } from "react";
import { useUploadedVideosContext } from "./UploadedVideosContext";
import { useTranslation } from "react-i18next";

export default function UploadVideoCard() {
  const theme = useTheme();
  const { palette } = theme;
  const { t } = useTranslation();

  const inputRef = useRef();

  const {
    handleVideoSelected,
    uploadStatus,
    uploadProgress,
    videoRef,
    canvasRef,
    videoSmallRef,
    canvasSmallRef,
  } = useUploadedVideosContext();

  function handleCardClick() {
    if (!uploadStatus) inputRef.current.click();
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        cursor: "pointer",
      }}
      onClick={handleCardClick}
    >
      <input
        ref={inputRef}
        accept=".mp4"
        onChange={handleVideoSelected}
        type="file"
        id="input_file"
        hidden
      ></input>
      <FontAwesomeIcon
        style={{
          color: uploadStatus === "uploadCompleted" ? palette.green.main : palette.primary.main,
          fontSize: "5vw",
          padding: "1vw",
          marginLeft: "-1vw",
        }}
        icon={faCloudUploadAlt}
      />
      <div
        style={{
          fontSize: "1.5vw",
          fontWeight: "semibold",
          fontFamily: "Poppins",
          cursor: "pointer",
          WebkitUserSelect: "none",
          color: palette.grey.normal,
        }}
      >
        {uploadStatus === "uploadCompleted"
          ? t("videoUploaded")
          : uploadStatus === "inProgress"
          ? `${uploadProgress}${t("percentUploadedVideo")}`
          : t("uploadVideo")}
      </div>
      {/* Tags needed in the background to create thumbnails_____ */}
      <video ref={videoRef} hidden />
      <canvas ref={canvasRef} hidden></canvas>
      <video ref={videoSmallRef} hidden />
      <canvas ref={canvasSmallRef} hidden></canvas>
      {/* END_____ */}
    </div>
  );
}
